// removed by extract-text-webpack-plugin
module.exports = {"accordeon":"_1iB-ep0tRcW4UgHH-fCd7Y","title":"_13BI34wtqcb8OiZgYCfnrZ","triangleRight":"_2mA4Dg2_NQpEMbu43JvTrQ","triangleDown":"_32PAvoKx3A-Et7kxW_i-ny","closed":"_34PsfJ5UcjbsZYUiSvuA2Y"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/sports-book/modules/basketball/css/accordion.css
// module id = 837
// module chunks = 0